import { render, staticRenderFns } from "./VoteButton.vue?vue&type=template&id=66af02cd&scoped=true&"
import script from "./VoteButton.vue?vue&type=script&lang=ts&"
export * from "./VoteButton.vue?vue&type=script&lang=ts&"
import style0 from "./VoteButton.vue?vue&type=style&index=0&id=66af02cd&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66af02cd",
  null
  
)

export default component.exports